import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import moment from "moment";
import store from "./store";
import icons from "./icons";
import BootstrapVue from "bootstrap-vue";
import PrimeVue from "./primevue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/assets/scss/common.scss";
import { EventBus } from "./EventBus";
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('primevue', PrimeVue);

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

icons.load();

Vue.config.productionTip = false;

Vue.filter("formatDate", (value) => {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format("DD-MMM-YYYY");
  }
});

Vue.filter("formatDateTime", (value) => {
  if (value) {
    return moment
      .utc(String(value))
      .local()
      .format("DD-MMM-YY HH:mm");
  }
});

// Vue.config.errorHandler = function(err, vm, info) {
//   console.log(`Error: ${err.toString()}\nInfo: ${info}`);
//   console.log(vm);
// };

Vue.mixin({
  methods: {
    copyText(text, container) {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.getElementById(container).appendChild(el);
      el.select();
      document.execCommand("copy");
      document.getElementById(container).removeChild(el);
      EventBus.$emit("toast", {
        title: "",
        message: "Copied to clipboard",
        variant: "success",
      });
    },
    scrollToLatestError() {
      let element = document.getElementsByClassName("form-group--error")[0];
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    },
    supportedFileTypesForWalletRequest(){
    return "PDF, DOC, DOCX, TXT, JPEG, PNG, GIF, BMP";
    }
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
